module.exports = __webpack_public_path__ + "img/mobile.2f0cb87a.svg";